"use client";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import Flower from "./flower";
import styles from "./login.module.css";
import useSWRMutation from "swr/mutation";
import axios from "axios";
import useUser, { useGoogleAuth, useOTPNew } from "hooks/useUser";
import { useLoginModal } from "states/modals";
import { Input } from "./input";
import { FiLoader, FiPackage } from "react-icons/fi";
import VerifyEmail from "./verify-email";
import { done } from "nprogress";
import { encryptData } from "helpers/encrypt";
import sanitizeData from "helpers/janitor";
import { VendorLink } from "./header.client";
// import { GoogleLogin } from "@react-oauth/google";
// import AES from "crypto-js/aes";
// import { enc } from "crypto-js";

async function login(
  url: string,
  {
    arg,
  }: {
    arg: {
      email: string;
      password: string;
    };
  }
) {
  var dat = {
    email: arg.email.toLowerCase(),
    password: arg.password,
  };

  const pl = encryptData(sanitizeData(dat));

  const response = await fetch("/api/encrypt", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      data: pl,
    }),
  });

  const res = await response.json();
  // console.log(res);

  const payload = res.encryptedPayload;

  const { data } = await axios.post(
    url,
    {
      payload,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data.data as User;
}

function Login({
  change,
  user = "user",
}: {
  change?: () => void;
  user?: "user" | "vendor";
}) {
  // console.log("PAGE LOAD");

  const { mutate, isLoading } = useUser();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState(false);
  const [activate, setActivate] = useState<string>();
  const [googling, setGoogling] = useState(false);
  const sendOTP = useOTPNew();
  const baseUrl = process.env.NEXT_PUBLIC_BACKEND_URL;

  const { setOpen } = useLoginModal();
  const withGoogle = useGoogleAuth();
  const { trigger, isMutating, error } = useSWRMutation("auth/login/", login, {
    onSuccess(data) {
      if (
        (user === "vendor" && data.role !== "vendor") ||
        !["vendor", "user"].includes(data.role)
      ) {
        setShowError(true);
        return;
      }
      localStorage.setItem("imprt", data.refresh);
      localStorage.setItem("uat", data.access);
      localStorage.setItem("uid", data.id);
      axios.defaults.headers.common["Authorization"] = "Bearer " + data.access;
      mutate(data);
      setOpen(false);
    },
    onError(err) {
      console.log(err);
    },
  });

  const authWithGoogle = async () => {
    setGoogling(true);
    const url = `${baseUrl}/auth/google/`;
    try {
      const response = await axios.get(url);
      window.open(response.data.authorization_url, "_self");
      console.log(response);
    } catch (error) {
      console.log("error", error);
    }
  };

  if (activate && sendOTP.data) {
    return <VerifyEmail email={activate} />;
  }
  return (
    <>
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          trigger({
            email,
            password,
          }).catch((e) => {
            if (e === "This account has not been activated") {
              setActivate(email);
            }
          });
          // const remember = form.get("remember");
        }}
      >
        <label className="sr-only" htmlFor="email">
          Email Address
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          name="email"
          id="email"
          placeholder="Email Address"
        />
        {error?.email ? <span>{error?.email}</span> : null}

        <Input
          label="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          type="password"
          name="password"
          id="password"
          placeholder="Password"
          minLength={8}
        />
        {error?.password ? <span>{error?.password}</span> : null}
        <span>
          <label>
            <input type="checkbox" name="remember" id="remember" />
            Remember me
          </label>

          <Link prefetch={false} href="/forgot-password" onClick={() => setOpen(false)}>
            Forgot Password?
          </Link>
        </span>
        {showError && (
          <span>You cannot login as a {user} with this account</span>
        )}
        {typeof error === "string" && (
          <span className="text-red-500">
            {error}{" "}
            {error === "This account has not been activated" && (
              <button
                type="button"
                className="btn btn-sm btn-green"
                disabled={sendOTP.isMutating}
                onClick={() => {
                  sendOTP.trigger({ email: activate as string });
                }}
              >
                {sendOTP.isMutating && <FiLoader className="animate-spin" />}
                Activate
              </button>
            )}
          </span>
        )}
        {/* {user === "user" && (
          <div className="flex-center">
            <GoogleLogin
              size="large"
              onSuccess={(data) => {
                withGoogle
                  .trigger({
                    auth_token: data.credential!,
                  })
                  .then((data) => {
                    mutate(data);
                    setOpen(false);
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              }}
            />
          </div>
        )} */}

        {typeof withGoogle.error === "string" && (
          <span>{withGoogle.error}</span>
        )}
        <button
          disabled={isMutating || isLoading || googling}
          type="submit"
          className="btn btn-lg btn-black"
        >
          {isMutating && <FiLoader className="animate-spin" />}
          {user === "vendor" ? "Vendor" : ""} Login
        </button>
        {/* <button
          onClick={(e) => {
            e.preventDefault();
            authWithGoogle();
          }}
          disabled={isMutating || isLoading || googling}
          className="btn btn-lg border-black border border-solid"
        >
          {googling ? (
            <FiLoader className="animate-spin" />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="0.98em"
              height="1em"
              viewBox="0 0 256 262"
            >
              <path
                fill="#4285f4"
                d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622l38.755 30.023l2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
              />
              <path
                fill="#34a853"
                d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055c-34.523 0-63.824-22.773-74.269-54.25l-1.531.13l-40.298 31.187l-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
              />
              <path
                fill="#fbbc05"
                d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82c0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602z"
              />
              <path
                fill="#eb4335"
                d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0C79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
              />
            </svg>
          )}
          Continue with Google
        </button> */}

        <p>
          Don&apos;t have an account?{" "}
          <Link
            prefetch={false}
            href={user === "vendor" ? "/become-a-seller" : "/register"}
            onClick={(e) => {
              if (change) {
                e.preventDefault();
                change();
                setTimeout(() => {
                  done();
                });
              }
              setOpen(false);
            }}
          >
            Sign up here
          </Link>
        </p>
      </form>
      <div className="flex items-center justify-center w-full gap-1">
        <div className={styles.or}>
          <Link
            prefetch={false}
            href="/become-a-seller"
            className={`btn ${
              user !== "vendor" ? "md:!bg-white !bg-[#f3f2ef]" : ""
            }`}
            onClick={() => setOpen(false)}
          >
            <Flower />
            Vendor Sign Up
          </Link>
        </div>
        {user !== "vendor" && (
          <div className={"flex justify-center md:hidden " + styles.or}>
            <VendorLink>
              <span
                className="flex items-center gap-2 btn bg-[#f3f2ef]"
                onClick={() => setOpen(false)}
              >
                <FiPackage />
                Vendor Login
              </span>
            </VendorLink>
          </div>
        )}
      </div>
    </>
  );
}

export default Login;
